import Qs from 'qs';
import { Notification } from 'element-ui';
import { i18n } from '@/translate';
import { hObjectIsEmpty } from '@/utils/helpers';
import { prepareErrorMessageForNotAcceptableStatus } from './errorsMessages';
import Router from '@/router';

export const serializeParamsInterceptor = (config) => {
  // eslint-disable-next-line no-param-reassign
  config.paramsSerializer = (params) => {
    const serializedParams = Qs.stringify(params, {
      arrayFormat: 'brackets',
      encode: false,
    });

    // add serialized empty params
    const serializedEmptyParams = Object.keys(params)
      .filter(param => typeof params[param] === 'object' && hObjectIsEmpty(params[param]))
      .map(param => `${param}[]`)
      .join('&');
    const _emptyParams = serializedEmptyParams.length === 0 ? '' : `&${serializedEmptyParams}`;
    return `${serializedParams}${_emptyParams}`;
  };

  return config;
};

export const errorHandlerInterceptor = (error) => {
  const errorMessage = i18n.tc(`http_errors.${error.response ? error.response.status : 500}`);
  const errorDescription = error.response.data.data.value ? error.response.data.data.value[0] : '';

  if (!Router.currentRoute.path === '/' && !error.reponse.status === 403) {
    Notification.error({
      title: errorMessage,
      message: errorDescription.charAt(0).toUpperCase() + errorDescription.slice(1),
      ...error.response.status === 406 && prepareErrorMessageForNotAcceptableStatus(error.response.data.data, error.response.config.url),
    });

    if (error.response.status === 403) {
      setTimeout(Router.push({ name: 'LoginRegister' }), 3000);
    }
  }

  return Promise.reject(error);
};
